exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.label[data-v-4a8de85d] {\n  border: 1px solid var(--theme-medium-gray);\n  border-right-width: 0;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  color: var(--theme-gray);\n}\n.select[data-v-4a8de85d] {\n  border: 1px solid var(--theme-medium-gray);\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  height: 100%;\n  padding-right: 20px;\n  -moz-appearance: none;\n  -webkit-appearance: none;\n  appearance: none;\n}\n.input[data-v-4a8de85d] {\n  position: relative;\n  height: 2.3em;\n}\n.absolute[data-v-4a8de85d] {\n  position: absolute;\n  right: 5%;\n  top: 40%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4a8de85d","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/registration/multiplePhonePlan/selectBox/DeviceInput.vue
// module id = 782
// module chunks = 0